import { render, staticRenderFns } from "./TwoFactorAuthModal.vue?vue&type=template&id=ed594ec2&"
import script from "./TwoFactorAuthModal.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed594ec2')) {
      api.createRecord('ed594ec2', component.options)
    } else {
      api.reload('ed594ec2', component.options)
    }
    module.hot.accept("./TwoFactorAuthModal.vue?vue&type=template&id=ed594ec2&", function () {
      api.rerender('ed594ec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Security/TwoFactorAuth/TwoFactorAuthModal.vue"
export default component.exports